import type { TypeRootState } from '@/store/store';

export const selectNavbarExpanded = (state: TypeRootState) => state.ui.navbarExpanded;
export const selectOpenBranches = (state: TypeRootState) => state.ui.openBranches;
export const selectRecentPaths = (state: TypeRootState) => state.ui.recentPaths;
export const selectCalendarHidden = (state: TypeRootState) => state.ui.calendarHidden ?? [];
